import React, { useContext } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import './index.css'
import DashboardPreview from '../dashboardPreview/index.js';
import Alert from "../../components/Alert";

function Preview() {
  const { master, loading } = useContext(BannerContext);

  return(
    <div style={{width: '100vw', height: '100vh', overflow: 'hidden'}}>      
      <Alert/>
      <div style={{position: 'absolute', width: '100%', height: '100%', background: 'rgba(0, 0, 0,0.7)', 
        display: loading.show ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center', zIndex: '999999999', flexDirection: 'column'}}>
        <div className="lds-facebook"><div></div><div></div><div></div></div>
        {
          loading.progress ?
          <div style={{position: 'relative', width: '300px', height: '30px', background: 'rgba(0, 0, 0,0.7)', borderRadius: '15px'}}>
            <span style={{ position: 'absolute', color: 'white', left: '137px',}}>{parseInt(loading.progress)}%</span>
            <div style={{transition: 'width 5s', width: loading.progress + "%", height: '30px', background: '#DC1A59',
            borderRadius: loading.progress < 95 ? '15px 0 0 15px'  : '15px'}}></div>
          </div>
          :
          <></>
        }
      </div>

      <DashboardPreview/>

    </div>
  )
}

export default Preview;
